import { Command } from "~/utils";
import { GameApi } from "./GameApi";
import { dummyGame } from "./dummyGame";

export const commandBuilderFactory = () => {
  const commandBuilder = Command.builder(GameApi(dummyGame(), ""));
  return {
    play: commandBuilder("play"),
    revealAll: () => commandBuilder("revealAll")(undefined),
    buyCard: commandBuilder("buyCard"),
    endBuyPhase: () => commandBuilder("endBuyPhase")(undefined),
    answerChoice: commandBuilder("answerChoice"),
    playIntrigue: commandBuilder("playIntrigue"),
    passIntrigue: () => commandBuilder("passIntrigue")(undefined),
    playGlobalEffect: () => commandBuilder("playGlobalEffect")(undefined),
    useTech: commandBuilder("useTech"),
  };
};
